import React, {FC, useMemo} from "react";
import {CardMedia} from "@material-ui/core";
import FlexBox from "view/components/Layout/FlexBox";

import getRandomArrayElement from "tools/common/getRandomArrayElement";
import {AnonymousOldShow} from "ts/api/show";
import useStyles from "./styles";

const imageModules = import.meta.glob(
  "/src/assets/images/show/backgroundPlaceholders/*.{png,jpg}",
  {eager: true}
);
const imagePlaceholders = Object.values(imageModules).map(
  (mod: any) => mod.default
);

type Props = {
  show: AnonymousOldShow & {organiserLogo?: string; organiserCompany?: string};
  isSolidCard?: boolean;
};

const ShowDetails: FC<Props> = ({show, isSolidCard}) => {
  const classes = useStyles({isSolidCard});

  const {showCardImageFile} = show;

  const backgroundImage = useMemo(
    () => showCardImageFile?.url || getRandomArrayElement(imagePlaceholders),
    [showCardImageFile]
  );

  return (
    <FlexBox justifyCenter>
      <FlexBox className={classes.container}>
        <CardMedia
          className={classes.image}
          component="img"
          image={backgroundImage}
          alt="Show Cover"
        />
      </FlexBox>
    </FlexBox>
  );
};

export default ShowDetails;
